
import { defineComponent, PropType } from 'vue';
import { TileModel } from '@/types/B2BcontentServerContract';

export default defineComponent({
    name: 'FallbackTile',
    props: {
        content: {
            type: Object as PropType<TileModel>,
            required: true,
        },
        alias: {
            type: String,
            default: '',
        },
    },
});
